/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import classNames from 'classnames';

import { ClientStatus } from 'enums/client.enum';
import { Disable, Enable } from 'components/Icons';

function ToggleStatusBtn(props) {
  const { formData, handleOnToggleAccountStatus, loading, disabled = false } = props;

  if (formData.status === ClientStatus.ACTIVE) {
    return (
      <motion.button
        onClick={handleOnToggleAccountStatus}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.9 }}
        type="submit"
        className={classNames(
          'px-[20px] py-[10px] rounded-2xl text-white font-ptScanCap bg-begoniaRed hover:bg-coralRed',
        )}
      >
        {loading ? (
          <span className="loading loading-infinity loading-lg" />
        ) : (
          <span className="text-base font-semibold flex flex-row items-center ">
            <Disable width={24} /> &nbsp; Disable
          </span>
        )}
      </motion.button>
    );
  }

  if (formData.status === ClientStatus.INACTIVE) {
    return (
      <motion.button
        onClick={handleOnToggleAccountStatus}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.9 }}
        type="submit"
        className={classNames(
          'px-[20px] py-[10px] rounded-2xl text-white font-ptScanCap bg-spaceCadetBlue80 hover:bg-spaceCadetBlue',
        )}
      >
        {loading ? (
          <span className="loading loading-infinity loading-lg" />
        ) : (
          <span className="text-base font-semibold flex flex-row items-center">
            <Enable width={24} /> &nbsp; Enable
          </span>
        )}
      </motion.button>
    );
  }
}

ToggleStatusBtn.propTypes = {
  formData: PropTypes.any,
  handleOnToggleAccountStatus: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ToggleStatusBtn;
